import { Modal } from '@material-ui/core';
import styled from 'styled-components/macro';

export const ModalContainerWrapper = styled(Modal)`
    display: flex;
    justify-content: center;
    align-items: center;
`;
